import gql from 'graphql-tag';

export const ABOUT_US_PAGE_SECTION_6_FRAGMENT = gql`
  fragment aboutUsPageSection6 on AboutUsPageSection6Type {
    section6Title
    section6Text
    section6ImageDesktop
    section6ImageMobile
    id
  }
`;
